<script setup>
// Sen: dzień pobudki, godziny zaśnięcia i wstania, jakość, notatki i drzemki.
// Zaśnięcie po godzinie pobudki liczy się do poprzedniego wieczoru. Godziny są
// opcjonalne — wieczorem można zapisać samo zaśnięcie i dopisać pobudkę rano.
import TimeInput from '@/components/v2/time-input.vue';
import DaySelect from '@/components/v2/add/day-select.vue';
import NapList from '@/components/v2/add/nap-list.vue';
import { useGender } from '@/composables/useGender.js';
import { useI18n } from 'vue-i18n';

defineProps({
    draft: { type: Object, required: true },
    errors: { type: Object, default: () => ({}) },
});
const emit = defineEmits(['update-naps']);
const { byGender } = useGender();
const { t } = useI18n();
</script>

<template>
    <div>
        <div class="grid grid-cols-1 sm:grid-cols-[1fr_auto_auto] gap-3 mb-4">
            <DaySelect :draft="draft" :label="t('entry.sleep.wakeDay')" input-id="v2-sleep-day" />

            <div class="sm:w-[124px]">
                <label class="v2-label" for="v2-bedtime">{{ t('entry.sleep.bedtime') }}</label>
                <TimeInput id="v2-bedtime" v-model="draft.bedtime" :invalid="!!errors.bedtime" :placeholder="t('entry.sleep.bedtimePlaceholder')" />
            </div>

            <div class="sm:w-[124px]">
                <label class="v2-label" for="v2-wake">{{ t('entry.sleep.wakeUp') }}</label>
                <TimeInput id="v2-wake" v-model="draft.wakeUpAt" :invalid="!!errors.wakeUpAt" :placeholder="t('entry.sleep.wakeUpPlaceholder')" />
            </div>
        </div>
        <p v-if="errors.bedtime || errors.wakeUpAt" class="text-[11.5px] text-[#B5643C] -mt-2 mb-3">
            {{ errors.bedtime || errors.wakeUpAt }}
        </p>
        <p v-else-if="!draft.bedtime || !draft.wakeUpAt" class="text-[11.5px] text-[#8A8378] -mt-2 mb-3">
            {{ !draft.wakeUpAt ? t('entry.sleep.noWakeUp') : t('entry.sleep.noBedtime') }}
        </p>

        <div class="mb-4 sm:w-[168px]">
            <label class="v2-label" for="v2-quality">{{ t('entry.sleep.quality') }} <span class="text-[#B8B0A3]">1–100</span></label>
            <input
                id="v2-quality"
                v-model="draft.quality"
                type="number"
                min="1"
                max="100"
                inputmode="numeric"
                class="v2-input v2-input--num"
                placeholder="—"
                :aria-invalid="!!errors.quality"
            />
            <p v-if="errors.quality" class="text-[11.5px] text-[#B5643C] mt-1">{{ errors.quality }}</p>
        </div>

        <div class="mb-4">
            <label class="v2-label" for="v2-sleep-notes">{{ t('entry.sleep.notes') }}</label>
            <textarea
                id="v2-sleep-notes"
                v-model="draft.sleepNotes"
                rows="2"
                class="v2-input v2-textarea"
                :placeholder="byGender(t('entry.sleep.notesPlaceholder.male'), t('entry.sleep.notesPlaceholder.female'))"
            ></textarea>
        </div>

        <div class="border-t border-[#EFE9DF] pt-4">
            <NapList :naps="draft.naps" :error="errors.naps" @update="list => emit('update-naps', list)" />
        </div>
    </div>
</template>
